<script lang="ts">
    import queryString from "query-string";
    import { Alert, Col, Container, Row } from "sveltestrap";
    import AngleStart from "../svg/shapes/AngleStart.svelte";
    import { appManager } from "../AppManagerStore";
    import { navigate } from "svelte-navigator";
    import { _ } from "svelte-i18n";

    let newPassword: string = "";
    let confirmPassword: string = "";
    let state: "unchanged" | "changed" | "failed" = "unchanged";
    let passConfirmed = false;

    $: if (typeof newPassword !== "undefined" && newPassword.length > 0) {
        passConfirmed = newPassword === confirmPassword;
    }

    let onSave = async () => {
        const parsed = queryString.parse(window.location.search);

        let token: string = "";
        if (typeof parsed.token !== "undefined") {
            token = atob(parsed.token as string);
        }
        let email: string = "";
        if (typeof parsed.email !== "undefined") {
            email = atob(parsed.email as string);
        }

        // confirm email, this also logs in the user.
        let confirmed = false;
        if (parsed.email && parsed.token) {
            confirmed = await $appManager.IdentityApi.resetPassword({
                email: email as string,
                code: token,
                password: newPassword,
            });
        }

        if (confirmed) {
            state = "changed";
            setTimeout(() => {
                navigate(`${$appManager.PublicUrl}signin`, { replace: true });
            }, 3000);
        } else {
            state = "unchanged";
        }
    };
</script>

<section>
    <Container class="d-flex flex-column">
        <Row class="align-items-center justify-content-center gx-0 min-vh-100">
            <Col>
                {#if state == "changed"}
                    <h1 class="mb-0 fw-bold">{$_("user.resetpass.thanks")} 👍</h1>

                    <p class="mb-6 text-muted">
                        {$_("user.resetpass.thankssubtitle")}
                    </p>

                    <p class="mb-6 text-muted">
                        {$_("user.resetpass.redirect.part1")}
                        <a href="{$appManager.PublicUrl}signin"
                            >{$_("user.resetpass.redirect.here")}</a>{$_("user.resetpass.redirect.part2")}
                    </p>
                {:else}
                    <h1 class="mb-0 fw-bold">{$_("user.resetpass.title")}</h1>

                    <p class="mb-6 text-muted">
                        {$_("user.resetpass.subtitle")}
                    </p>

                    <div class="mb-6">
                        <div class="form-group mb-5">
                            <label class="form-label" for="newpassword">
                                {$_("user.resetpass.newpassword")}
                            </label>
                            <input
                                type="password"
                                class="form-control"
                                id="newpassword"
                                placeholder={$_(
                                    "user.resetpass.newpasswordplaceholder"
                                )}
                                bind:value={newPassword} />
                        </div>
                        <div class="form-group mb-5">
                            <label class="form-label" for="confirmpassword">
                                {$_("user.resetpass.confirmpassword")}
                            </label>
                            <input
                                type="password"
                                class="form-control"
                                id="confirmpassword"
                                placeholder={$_(
                                    "user.resetpass.confirmpasswordplaceholder"
                                )}
                                bind:value={confirmPassword} />
                        </div>

                        <button
                            class="btn w-100 btn-primary {passConfirmed
                                ? ''
                                : 'disabled'}"
                            on:click={async () => await onSave()}>
                            {$_("user.resetpass.ok")}
                        </button>
                    </div>

                    {#if state == "failed"}
                        <Alert class="mt-2"
                            >{$_("user.resetpass.error.message")}<br />
                            {$_("user.resetpass.error.part1")}
                            <a href="{$appManager.PublicUrl}forgotpassword"
                                >{$_("user.resetpass.error.signup")}</a>.</Alert>
                    {/if}

                    <p class="mb-0 fs-sm text-muted">
                        {$_("user.resetpass.remember")}
                        <a href="{$appManager.PublicUrl}signin"
                            >{$_("user.signup.signin")}</a
                        >.
                    </p>
                {/if}
            </Col>

            <div
                class="col-lg-7 offset-lg-1 align-self-stretch d-none d-lg-block">
                <div
                    class="h-100 w-cover bg-cover"
                    style="background-image: url(/img/covers/cover-15.jpg);" />

                <div class="shape shape-start shape-fluid-y text-white">
                    <AngleStart />
                </div>
            </div>
        </Row>
    </Container>
</section>
